<template>
    <div class="content">
        <div v-show="!showPay" class="list" v-for="(items,index) in list" :key="index">
            <div class="title">{{items.title}}</div>
            <div class="msg">
                <div :class="{'off':!items.on,'text':true}" >{{items.text}}</div>
                <div v-if="!items.on" class="btn" @click="goToPay(items.val)">{{items.btnText}}</div>
            </div>

        </div>

        <div v-show="showPay"  class="pay">
            <div class="payTitle">微信扫码付费阅读：2元/次</div>
            <div class="payImg">
                <canvas id="QRCode" width="300" height="150"></canvas>
                <img :src="payImg" alt="">
            </div>
        </div>

    </div>
</template>

<script>
    import axios from 'axios'
    import QRCode from 'qrcode'
    export default {
        name: "Consultation",
        data(){
            return{
                timer:'',
                tradeNo:'',
                showPay:false,
                payImg:'',
                QRCodeMsg: '',
                list:[
                    {
                        title:'互联网大数据',
                        text:'首先，互联网大数据目前已经形成了一个庞大的生态体系，这里面既包括技术体系，也包括业务体系，涉及到的环节包括数据采集、数据整理、存储、安全、分析、呈现和应用，随着大数据不断开始落地到行业领域，大数据自身也正在开辟出越来越大的价值空间。要想解释清楚互联网大数据，需要从多个角度来进行解读，涉及到技术体系，业务体系和发展趋势等多个方面。从技术体系结构来看，大数据的技术体系以大数据平台为核心，而大数据平台则以分布式存储和分布式计算来展开。目前大数据技术体系已经趋于成熟，基于大数据平台的生态体系也已经形成了一定的规模。大数据平台的作用就是完成大数据的技术实现，行业领域可以基于大数据平台来完成各种大数据创新应用。从业务体系来看，大数据本身就打开了一个新的价值空间，这个价值空间就是数据价值，由于互联网本身就会产生源源不断的数据，所以大数据的价值增量也会源源不断。不同的业务体系会产生不同的数据，所以其产生的大数据价值也会有所不同。在产业互联网时代，行业领域的数据价值将逐渐得到体现。从发展趋势来看，在产业互联网的推动下，大数据的发展趋势将逐渐向智能化领域发展，由于人工智能是大数据应用的重要出口，所以未来大数据在人工智能的发展过程中会获得越来越多的关注。',
                        btnText:'2元阅读',
                        val:0,
                        on:false

                    },
                    {
                        title:'互联网的可发展性',
                        text:'要想解释清楚互联网大数据，需要从多个角度来进行解读，涉及到技术体系，业务体系和发展趋势等多个方面。从技术体系结构来看，大数据的技术体系以大数据平台为核心，而大数据平台则以分布式存储和分布式计算来展开。目前大数据技术体系已经趋于成熟，基于大数据平台的生态体系也已经形成了一定的规模。大数据平台的作用就是完成大数据的技术实现，行业领域可以基于大数据平台来完成各种大数据创新应用。\n' +
                            '\n' +
                            '从业务体系来看，大数据本身就打开了一个新的价值空间，这个价值空间就是数据价值，由于互联网本身就会产生源源不断的数据，所以大数据的价值增量也会源源不断。不同的业务体系会产生不同的数据，所以其产生的大数据价值也会有所不同。在产业互联网时代，行业领域的数据价值将逐渐得到体现。\n' +
                            '\n' +
                            '从发展趋势来看，在产业互联网的推动下，大数据的发展趋势将逐渐向智能化领域发展，由于人工智能是大数据应用的重要出口，所以未来大数据在人工智能的发展过程中会获得越来越多的关注。',
                        btnText:'2元阅读',
                        val:1,
                        on:false

                    },
                    {
                        title:'互联网8K直播背后的技术实现',
                        text:'阿里巴巴杭州西溪园区，距离深圳云栖大会的会场1300公里，如何保证这么远距离的大数据量稳定传输，又是一个难题。\n' +
                            '\n' +
                            '如图所示，通过专线，把直播现场（阿里巴巴杭州西溪园区）连接到阿里云网络（杭州），使用深圳的视频云直播中心，来做中间的直播流数据接收转发和处理。阿里云高速通道连接了阿里云（杭州）和深圳视频直播中心，最后通过专线，连接观众现场与阿里云（深圳）CDN网络。\n' +
                            '\n' +
                            '视频播放\n' +
                            '\n' +
                            '如果想要体验8K视频带来的高清晰画质和震撼的感觉，就需要强大的视频播放端能力。为保障本次8K视频高质量，本次直播使用了阿里云视频云自研的8K播放器，可以码流缓冲处理，可抗网络抖动。8K高清播放需要强大的解码能力，阿里视频云自研的8K视频播放软件不仅具有软件解码能力，也支持GPU硬件解码加速，可对渲染流水线上的性能状态进行监测，实时解码，保障播放流畅。',
                        btnText:'2元阅读',
                        val:2,
                        on:false

                    }
                ]
            }
        },
        watch: {
            QRCodeMsg(val) {
                // 获取页面的canvas
                var msg = document.getElementById('QRCode')
                // 将获取到的数据（val）画到msg（canvas）上
                QRCode.toCanvas(msg, val, function (error) {
                    if (error) {
                        console.log(error)
                    }
                })
            }
        },
        methods:{
            goToPay(n){
                let go = confirm('请微信扫码付费阅读')
                if(go){
                    let url=`${window.location.origin}/gonghao/wechat_code/`
                    console.log(url)
                    axios.post(url)
                        .then(item => {

                            this.QRCodeMsg = item.data.qrcode_img
                            this.showPay=true
                            this.tradeNo=item.data.order_no
                            console.log(item)
                            this.searchPay(n)
                        })
                        .catch(function(err){
                            console.log(err);
                        });

                }


            },
            searchPay(n){
                let trade=this.tradeNo;
                let self=this;
                let url=`${window.location.origin}/gonghao/order_status/?trade_no=${trade}`
                console.log(11,trade,url)
                this.timer=setInterval(()=>{
                    axios.get(url)
                        .then(item => {
                            console.log(item)
                            let state=item.data.trade_state
                            if(state === 'SUCCESS'){
                                clearInterval(self.timer)
                                this.timer=null;
                                this.showPay=false;
                                this.list[n].on=true;
                            }else if (state === 'CLOSED' || state === 'REVOKED' || state === 'PAYERROR'){
                                alert('支付失败')
                                this.showPay=false;
                                clearInterval(this.timer)
                                this.timer=null;
                            }

                        })
                        .catch((err)=>{
                            console.log(err,'报错');
                            clearInterval(this.timer)
                            this.timer=null;
                            this.showPay=false;
                        });
                },1000)

            }
        }
    }
</script>

<style scoped lang="scss">

    .content{
        width: 100%;
    }
    .list{
        padding: 0 120px 40px;
        width: 100%;
        display: flex;
        justify-content: center;
        align-items: flex-start;
        flex-direction: column;
        border-bottom: 2px dashed #979797;
        margin-bottom: 40px;
        .title{
            font-size:42px;
            font-family:PingFangSC-Medium,PingFang SC;
            font-weight:500;
            color:rgba(51,51,51,1);
            letter-spacing:2px;
            text-align: left;
            line-height: 59px;
            margin-bottom: 16px;
        }
        .msg{
            width: 100%;
            display: flex;
            justify-content: space-between;
            align-items: center;
            .text{
                font-size:28px;
                font-family:PingFangSC-Regular,PingFang SC;
                font-weight:400;
                color:rgba(102,102,102,1);
                letter-spacing:2px;
                width: 1384px;
                line-height:40px;

                text-align: left;
            }
            .btn{
                cursor: pointer;
                display: flex;
                align-items: center;
                justify-content: center;
                width:234px;
                height:95px;
                background:rgba(158,60,60,1);
                border-radius:48px;
                border:5px solid rgba(220,209,180,1);
                font-size:42px;
                font-family:PingFangSC-Regular,PingFang SC;
                font-weight:400;
                color:rgba(255,255,255,1);
            }
        }
    }
    .payTitle{
        text-align: center;
        width: 100%;
        height:65px;
        font-size:46px;
        font-family:PingFangSC-Medium,PingFang SC;
        font-weight:500;
        color:rgba(51,51,51,1);
        margin: 20px 0 40px;
        letter-spacing:2px;
    }
    .payImg{
        width: 100%;
        height: 496px;
        display: flex;
        justify-content: center;
        align-items: center;
        margin-bottom: 60px;

    }

    .off{
        height: 88px;
        text-overflow: -o-ellipsis-lastline;
        overflow: hidden;
        text-overflow: ellipsis;
        display: -webkit-box;
        -webkit-line-clamp: 2;
        line-clamp: 2;
        -webkit-box-orient: vertical;
    }
    #QRCode{
        width: 496px;
        height: 496px;
    }

</style>